'use client';

import { SessionProvider } from 'next-auth/react';
import { useEffect } from 'react';
import type { Session } from 'next-auth';
import { useOffline } from '@/contexts/OfflineProvider';
import { resolveApiRequestUrl } from '@/lib/routing/api-requests';

function MenuSyncHandler() {
  const { registerSyncHandler, isOnline } = useOffline();

  useEffect(() => {
    const unregister = registerSyncHandler('menu', async (action) => {
      try {
        let url = '';
        let body: Record<string, unknown> = {};

        switch (action.type) {
          case 'submit_service_feedback': {
            url = '/api/public/service-feedback';
            body = action.payload as Record<string, unknown>;
            break;
          }
          case 'create_service_request': {
            url = '/api/public/service-requests';
            body = action.payload as Record<string, unknown>;
            break;
          }
          default:
            return false;
        }

        const res = await fetch(resolveApiRequestUrl(url), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        return res.ok;
      } catch {
        return false;
      }
    });
    return unregister;
  }, [registerSyncHandler]);

  return null;
}

export default function MenuLayoutClient({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <SessionProvider basePath="/api/customer-auth" session={session} refetchInterval={300}>
      {/* `overflow-x-clip`, not `-hidden`: `hidden` forces overflow-y:auto and
          makes this a scroll container, which stops `position: sticky` working
          for the whole customer menu inside it. See app/m/[slug]/layout.tsx. */}
      <section className="mnrq-menu-route min-h-screen w-full overflow-x-clip bg-[var(--color-bg)] text-[var(--color-text)]">
        <MenuSyncHandler />
        {children}
      </section>
    </SessionProvider>
  );
}
